import ResultsContainer from './ResultsContainer';

export default ResultsContainer;
